import './bling';
import 'intersection-observer';
import scrollama from 'scrollama';
import imgs from '../../assets/images/*.jpg';

function renderTimeline() {
  const tlScroller = scrollama(); // listener for TL marker ticks

  //   $1('button.lights').on('click', e => {
  //     let theme = document.documentElement.getAttribute('data-theme');
  //     document.documentElement.setAttribute(
  //       'data-theme',
  //       theme == 'dark' ? 'light' : 'dark'
  //     );
  //     e.target.innerText = theme !== 'dark' ? 'Lights on' : 'Lights off';
  //   });

  function handleStepEnter({ element: el, index }) {
    let headerDate = el
      .querySelector('.content__date')
      .getAttribute('data-date');
    let tickMarker = $1(`.tick__marker[data-date="${headerDate}"]`);
    let tickDash = tickMarker.nextElementSibling;
    let tickDate = tickDash.nextElementSibling;

    tickMarker.classList.add('tick__marker--active');
    tickDash.style.opacity = 1;
    tickDate.style.opacity = 1;

    if (index >= 0) {
      hideShowTimeilne(1);
    }
  }

  function handleExit({index}) {
    $('.tick__marker').forEach(d => d.classList.remove('tick__marker--active'));
    $(
      '.tick:not(:first-child):not(:last-child) .tick__date, .tick:not(:first-child):not(:last-child) .tick__date-dash'
    ).forEach(d => (d.style.opacity = 0));

    if (index >= 67 | index <= 0) {
      hideShowTimeilne(0);
    }
  }

  function hideShowTimeilne(opacity) {
    const timeline = $1('.timeline');
    const fab = $1('.timeline__fab');
    if (window.innerWidth > 1000) {
      if (timeline.style.opacity !== opacity) {
        timeline.style.opacity = opacity;
      }
    } else {
      if (fab.style.opacity !== opacity) {
        fab.style.opacity = opacity;
      }
    }
  }

  function initScroller() {
    tlScroller
      .setup({
        step: '.app__content .content-wrapper',
        debug: false
      })
      .onStepEnter(handleStepEnter)
      .onStepExit(handleExit);

    window.addEventListener('resize', function() {
      tlScroller.resize;
    });
  }

  function createTicks() {
    const dates = $('.app__content .content-wrapper .content__date');
    let timelineT = $1('.timeline__ticks');

    for (let index = 0; index < dates.length; index++) {
      let tick = document.createElement('div');
      let date = dates[index].getAttribute('data-date');
      tick.className = 'tick';
      tick.innerHTML = `<div class="tick__marker" data-date="${date}"></div><div class="tick__date-dash"></div><span class="tick__date">${date}</span>`;

      tick.on('click', function(e) {
        if (e.target.className == 'tick__date') return;

        let head = dates[index].parentElement;
        head.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      timelineT.appendChild(tick);
    }
  }

  function initLayout() {
    document.documentElement.setAttribute('data-theme', 'dark');

    $('.mobile-app-hidden').forEach(el =>
      el.classList.remove('mobile-app-hidden')
    );
    $1('.mobile-app-redirect').remove();

    $('.content__image img').forEach(el => {
      el.src = imgs[el.dataset.src];
    });

    $1('.timeline__fab').on('click', function(e) {
      const tlWrapper = $1('.timeline-wrapper');
      const timeline = $1('.timeline');
      const fab = $1('.timeline__fab');

      fab.classList.toggle('timeline__fab--open');
      tlWrapper.classList.toggle('timeline-wrapper--open');
      timeline.classList.toggle('timeline--open');
    });
  }

  initLayout();
  createTicks();
  initScroller();
}

export { renderTimeline };
